import {
  disableBodyScroll,
  enableBodyScroll
} from 'body-scroll-lock';
import { initForms } from './form';
import { placeholder } from './placeholder';

let popupTimerId = null;
let popupCloseTimerId = null;

const bodyScrollOptions = {
  reserveScrollBarGap: true
};

function getTransitionDuration (el) {
  return parseFloat(getComputedStyle(el, null).transitionDuration, 10) * 1000;
}

async function fetchAsync (url) {
  let response = await fetch(url);
  let data = await response.text();
  let parser = new DOMParser();
  let doc = parser.parseFromString(data, 'text/html');
  return doc.body;
}

const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.attributeName === 'style') {
      if (document.querySelector('.header__fixed')) {
        document.querySelector('.header__fixed').style.paddingRight = document.body.style.paddingRight;
      }
    }
  });
});

// Notify me of style changes
const observerConfig = {
  attributes: true,
  attributeFilter: ['style']
};

window.addEventListener('load', () => {
  observer.observe(document.body, observerConfig);
});

function openPopup (button, url, target, index) {
  let containerIndex;
  if (index) {
    containerIndex = index;
  } else {
    containerIndex = 1;
  };

  const popupNode = document.querySelector('.popup-container--container' + containerIndex);
  const popupNodeScroll = popupNode.querySelector('.popup-container__scroll');
  const popupContentWrapperNode = popupNode.querySelector('.popup-container__wrapper');

  return new Promise((resolve, reject) => {
    let buttonNode;
    let popupUrl;

    if (button) {
      buttonNode = button;
      popupUrl = buttonNode.href;
    }

    const newUrl = new URL(popupUrl || window.location.origin + url);
    const urlSearchParams = new URLSearchParams(newUrl.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    function afterOpened () {
      document.body.classList.add('modal-opened');

      const popupTypeEl = popupNode.querySelector('[data-popup]');
      let popupType;

      if (popupTypeEl) {
        popupType = popupTypeEl.dataset['popup'];

        popupNode.setAttribute('data-popup', popupType);

        if (popupType === 'project') {
          function closePos () {
            popupNode.querySelector('.popup__close').style.right = document.documentElement.offsetWidth - popupNode.querySelector('.popup-project__block').getBoundingClientRect().right + 'px';
          }

          closePos();

          window.addEventListener('resize', () => {
            closePos();
          });
        }
      }

      setTimeout(() => {
        initForms(popupNode);
        placeholder(popupNode);

        const focusInput = popupNode.querySelector('.js-focus');

        if (focusInput) {
          focusInput.focus();
        }
        resolve(popupNode);
      }, 100);
    }

    function afterFetch () {
      setTimeout(() => {
        afterOpened();
        popupNode.classList.add('popup-container--active');
        popupNode.classList.add('popup-container--afteractive');
        setTimeout(() => {
          popupNode.classList.add('popup-container--afteropened');
          window.dispatchEvent(new Event('resize'));
        }, 0);
      }, 10);
    }

    function popup () {
      clearTimeout(popupTimerId);

      if (buttonNode && (url || buttonNode.getAttribute('href').charAt(0) !== '#')) {
        const urlToFetchLink = url || popupUrl;
        const urlToFetch = new URL(urlToFetchLink);
        urlToFetch.searchParams.set('xhr', '1');
        fetch(urlToFetch.toString())
          .then(response => response.text())
          .then(html => {
            disableBodyScroll(popupNodeScroll, bodyScrollOptions);
            popupNode.style.display = null;
            popupContentWrapperNode.innerHTML = html;
            afterFetch();
          })
          .catch(function (err) {
            console.log('Failed to fetch page: ', err);
            reject(err);
          });
      } else {
        disableBodyScroll(popupNodeScroll, bodyScrollOptions);
        popupNode.style.display = null;
        const hash = target || buttonNode.hash;
        popupContentWrapperNode.innerHTML = document.querySelector(hash).innerHTML;
        afterFetch();
      }
    }

    if (popupNode) {
      const popupTypeEl = popupNode.querySelector('.popup[data-popup]');
      let popupType;

      if (popupTypeEl) {
        popupType = popupTypeEl.dataset['popup'];

        popupNode.setAttribute('data-popup', popupType);
      }

      popup();
    }
  });
}

function closePopup (target, container) {
  let popupNodeActive;
  if (target) {
    popupNodeActive = target.closest('.popup-container--active');
  } else if (container) {
    popupNodeActive = container.closest('.popup-container--active');
  } else {
    popupNodeActive = document.querySelector('.popup-container--active');
  }
  if (popupNodeActive) {
    enableBodyScroll(popupNodeActive.querySelector('.popup-container__scroll'), bodyScrollOptions);
    clearTimeout(popupCloseTimerId);
    document.body.classList.remove('modal-opened');

    popupNodeActive.classList.remove('popup-container--afteropened');
    popupNodeActive.classList.remove('popup-container--afteractive');

    setTimeout(() => {
      popupNodeActive.querySelector('.popup-container__scroll').scrollTo(0, 0);
      popupNodeActive.classList.remove('popup-container--active');
      const duration = getTransitionDuration(popupNodeActive);

      popupCloseTimerId = setTimeout(() => {
        popupNodeActive.style.display = 'none';
        popupNodeActive.querySelector('.popup-container__wrapper').textContent = '';
        popupNodeActive.querySelector('.popup-container__wrapper').style.transform = 'none';
        popupNodeActive.querySelector('.popup-container__wrapper').setAttribute('data-y', 0);
        popupNodeActive.dataset['popup'] = '';
      }, duration);
    }, 0);
  }
}

// click events
document.addEventListener('click', (e) => {
  //  click event: open popup
  if (e.target.matches('.js-popup-open')) {
    e.preventDefault();
    openPopup(e.target);
  } else if (e.target.matches('.js-popup-open *')) {
    e.preventDefault();
    openPopup(e.target.closest('.js-popup-open'));
  }

  //  click event: open popup2
  if (e.target.matches('.js-popup2-open')) {
    e.preventDefault();
    openPopup(e.target, false, false, 2);
  } else if (e.target.matches('.js-popup2-open *')) {
    e.preventDefault();
    openPopup(e.target.closest('.js-popup2-open'), false, false, 2);
  }

  //  click event: close popup (button)
  if (e.target.matches('#popup-close, #popup-close *')) {
    closePopup(e.target);
  }

  if (e.target.matches('[data-close], [data-close] *')) {
    closePopup(e.target);
  }

  //  click event: close popup (overlay)
  if (!e.target.closest('.popup')) {
    // console.log(e.target);
    closePopup();
  }
});

export { openPopup, closePopup, fetchAsync };
